import TranslateService from "./translate.service";

class ErrorMessage {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getErrorMessage(validatorValue?: any): any {
    return {
      required: TranslateService.translate("required"),
      email: TranslateService.translate("email"),
      confirmPassword: TranslateService.translate("confirmPassword"),
      minPlayer: `${TranslateService.translate("minPlayer")} ${validatorValue}`,
      maxPlayer: `${TranslateService.translate("maxPlayer")} ${validatorValue}`
    };
  }

  getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    return this.getErrorMessage(validatorValue)[validatorName];
  }
}

export default new ErrorMessage();
